import * as React from "react";

import KaiImage from "../../assets/inagaki_kai.jpg";
import YuseiImage from "../../assets/naito.png";
import TeruImage from "../../assets/teruoka_hajime.jpg";
import MiyajimaImage from "../../assets/miyajima_daichi.jpg";
import YanoImage from "../../assets/yano.jpg";
import MitsuokaImage from "../../assets/mitsuoka.jpg";
import TsurutaImage from "../../assets/tsuruta.jpg";
import TaneImage from "../../assets/tane.jpg";
import JinImage from "../../assets/ito_jin.png";

const MEMBERS = [
  {
    image: KaiImage, name: "稲垣 海", lead: "代表", x_id: "Kai_Inagaki",
    bio: "東京農工大卒、奈良先端大でロボット学習を研究。FLLで日本4位、高専ロボコン入賞、KIKSでSSL、FRCを立ち上げ初年度でハワイ大会出場。2025年トヨタ自動車未来創生センター入社。",
  },
  {
    image: YuseiImage, name: "内藤 優星", lead: "副代表", x_id: "vitz787b",
    bio: "奈良先端大修了。KIKSでリーダー・AI班として世界大会へ。探索×深層学習の研究でロボカップ研究賞、2021年AP大会で日本ロボット学会賞。2024年トヨタ自動車未来創生センター入社。",
  },
  {
    image: MiyajimaImage, name: "宮島 大知",
    bio: "豊田高専専攻科修了。高専ロボコンで機械設計・加工、KIKSでは通信と制御を担当。2021年AP大会で日本ロボット学会賞。",
  },
  {
    image: MitsuokaImage, name: "光岡 稜真",
    bio: "名古屋大大学院修了。豊田高専で高専ロボコン・SSLに出場しハードウェア製作を担当。2021年AP大会で日本ロボット学会賞。現在は名大博士後期課程でHRIを研究。",
  },
  {
    image: TaneImage, name: "種 泰輔",
    bio: "豊橋技科大大学院修了。KIKSでAI班、FRC立ち上げでハワイ大会出場。学生ロボコンで画像認識を担当し日本優勝・世界BEST ENGINEERING AWARD。現在はメーカー開発職。",
  },
  {
    image: JinImage, name: "伊藤 仁",
    bio: "慶應義塾大大学院修了。倒立振子ロボットの最適制御や冗長マニピュレータのロバスト制振制御を研究。現在はメーカーでロボティクス研究に従事。"
  },
  {
    image: TsurutaImage, name: "鶴田 泰隆",
    bio: "電通大大学院修了。豊田高専で高専ロボコンの設計、SSLのAI開発を担当。2021年AP大会で日本ロボット学会賞。現在は某家電メーカー開発職。",
  },
  {
    image: TeruImage, name: "照岡 肇",
    bio: "奈良先端大修了。大阪工大で二足歩行ロボコンなどに出場しハードウェア設計を担当。現在は強化学習の理論解析に関する研究に従事。",
  },
  {
    image: YanoImage, name: "矢野 嘉希",
    bio: "奈良先端大修了。大規模言語モデルと強化学習を併用したマルチロボット制御を研究。現在はメーカー勤務。",
  },
];

function Members() {
  return (
    <section className="trps-section trps-dark2" id="Member">
      <div className="trps-wrap">
        <h2 className="trps-h">メンバー</h2>
        <p className="trps-sub">
          ロボット・AI分野で経験を積んできたエンジニアや研究者を中心に、多様なメンバーが集まっています。
        </p>

        <div className="trps-members">
          {MEMBERS.map((m) => (
            <article className="trps-member" key={m.name}>
              <div className="trps-member__media">
                {m.lead && <span className="trps-member__lead">{m.lead}</span>}
                <img src={m.image} alt={m.name} loading="lazy" />
              </div>
              <div className="trps-member__body">
                {m.lead && <p className="trps-member__position">{m.lead}</p>}
                <h3 className="trps-member__name">{m.name}</h3>
                <p className="trps-member__bio">{m.bio}</p>
                {m.x_id && (
                  <a
                    className="trps-member__x"
                    href={`https://twitter.com/${m.x_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ↳ @{m.x_id}
                  </a>
                )}
              </div>
            </article>
          ))}

          <aside className="trps-member-more" aria-label="このほかにもTRAPSで活動するメンバーがいます">
            <span className="trps-member-more__ellipsis" aria-hidden="true">…</span>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default Members;
